import React from 'react';
import {FormattedMessage} from 'react-intl';

// En-tête de page (titre + description) — même style que l'écran Paramètres.
// `title` et `description` sont des identifiants de messages react-intl.
const PageHeader = ({title, description}) => (
  <div className="ccv2-page-head">
    <h1 className="ccv2-page-title"><FormattedMessage id={title}/></h1>
    <p className="ccv2-page-subtitle"><FormattedMessage id={description}/></p>
  </div>
);

export default PageHeader;
